import * as React from "react";
function BagPersonalItemIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.75H9a1.76 1.76 0 0 0-1.75 1.75v4A1.76 1.76 0 0 0 9 20.25h6a1.76 1.76 0 0 0 1.75-1.75v-4A1.76 1.76 0 0 0 15 12.75m-6 1.5h6a.25.25 0 0 1 .25.25v.62h-6.5v-.62a.25.25 0 0 1 .25-.25m6 4.5H9a.25.25 0 0 1-.25-.25v-1.88h3.5v.26a.75.75 0 0 0 1.5 0v-.26h1.5v1.88a.25.25 0 0 1-.25.25m.69-14.33a3.73 3.73 0 0 0-7.38 0A4.74 4.74 0 0 0 4.75 9v11.5A2.25 2.25 0 0 0 7 22.75h10a2.25 2.25 0 0 0 2.25-2.25V9a4.74 4.74 0 0 0-3.56-4.58M12 2.75a2.24 2.24 0 0 1 2.11 1.5H9.89A2.24 2.24 0 0 1 12 2.75m5.75 17.75a.76.76 0 0 1-.75.75H7a.76.76 0 0 1-.75-.75V9A3.26 3.26 0 0 1 9.5 5.75h5A3.26 3.26 0 0 1 17.75 9z"
  }));
}
export default BagPersonalItemIcon;